(() => {
	// Load the Javascript file
	const loadJavascriptFile = (url, callback) => {
		var script = document.createElement("script");
		script.onload = callback;
		script.src = url;
		document.head.appendChild(script);
	};

	// Load the Swiper CSS and JS
	const swiperJs = (callback) => {
		// Insert Swiper CSS first
		const swiperCSS = document.createElement("link");
		swiperCSS.setAttribute("rel", "stylesheet");
		swiperCSS.setAttribute("href", "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css");
		document.head.appendChild(swiperCSS);

		// Then load Swiper JS
		loadJavascriptFile("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js", () => {
			callback();
		});
	};

	// Get the grid container
	const gridContainer = document.querySelector(".shopify-section .js-grid");

	// Create a container for the carousel
	const carouselContainer = document.createElement("div");
	carouselContainer.classList.add("dlt-carousel-container");

	// Wrap the grid container with the carousel container
	gridContainer.parentNode.insertBefore(carouselContainer, gridContainer);
	carouselContainer.appendChild(gridContainer);

	// Initialise Swiper
	swiperJs(() => {
		// Add swiper class to the grid container
		gridContainer.classList.add("swiper");

		// Get all product items
		const productItems = gridContainer.querySelectorAll("product-grid-item");

		// Create swiper-wrapper element
		const swiperWrapper = document.createElement("div");
		swiperWrapper.classList.add("swiper-wrapper");

		// Move all product items into the swiper-wrapper
		productItems.forEach((item) => {
			// Add swiper-slide class to each product item
			item.classList.add("swiper-slide");
			// Append to the wrapper (this will move them from their current location)
			swiperWrapper.appendChild(item);

			// Get the badge and title wrapper
			const badge = item.querySelector(".product__badge");
			const titleWrapper = item.querySelector(".product__grid__title__wrapper");

			// If the badge and title wrapper exist, create a new wrapper and append the title wrapper and badge to it
			if (badge && titleWrapper) {
				const newWrapper = document.createElement("div");
				newWrapper.classList.add("product__title__badge__wrapper");
				titleWrapper.insertAdjacentElement("afterend", newWrapper);
				newWrapper.appendChild(titleWrapper);
				newWrapper.appendChild(badge);
			}
		});

		// Add the wrapper to the grid container
		gridContainer.appendChild(swiperWrapper);

		// Create gradient overlays for the sides
		const leftGradient = document.createElement("div");
		leftGradient.classList.add("dlt-carousel-gradient", "dlt-carousel-gradient-left");
		leftGradient.style.display = "none"; // Initially hidden

		const rightGradient = document.createElement("div");
		rightGradient.classList.add("dlt-carousel-gradient", "dlt-carousel-gradient-right");

		// Add gradients to the carousel container
		carouselContainer.appendChild(leftGradient);
		carouselContainer.appendChild(rightGradient);

		// Create a container for navigation buttons outside the swiper
		const navContainer = document.createElement("div");
		navContainer.classList.add("swiper-nav-container");
		navContainer.classList.add("jdgm-carousel__arrows");

		// Create navigation buttons
		const prevButton = document.createElement("div");
		prevButton.classList.add("jdgm-carousel__left-arrow");

		const nextButton = document.createElement("div");
		nextButton.classList.add("jdgm-carousel__right-arrow");

		// Append navigation buttons to the nav container
		navContainer.appendChild(prevButton);
		navContainer.appendChild(nextButton);

		// Insert the nav container after the swiper container
		gridContainer.parentNode.insertAdjacentElement("afterend", navContainer);

		// Initialise Swiper
		const swiper = new Swiper(".shopify-section .js-grid", {
			effect: "slide",
			speed: 500,
			navigation: {
				prevEl: ".jdgm-carousel__left-arrow",
				nextEl: ".jdgm-carousel__right-arrow"
			},
			slidesPerView: 2.3,
			spaceBetween: 20,
			centeredSlides: false,
			loop: false,
			slidesOffsetAfter: 20,
			slidesOffsetBefore: 20,
			breakpoints: {
				// when window width is >= 768px
				768: {
					slidesPerView: 4.1,
					spaceBetween: 20,
					slidesOffsetAfter: 40,
					slidesOffsetBefore: 40
				}
			},
			on: {
				init: function () {
					// Right gradient is visible initially (not at the end)
					if (!this.isEnd) {
						rightGradient.style.display = "block";
					}
				},
				slideChange: function () {
					// Show left gradient if not at the beginning
					leftGradient.style.display = this.isBeginning ? "none" : "block";

					// Show right gradient if not at the end
					rightGradient.style.display = this.isEnd ? "none" : "block";
				}
			}
		});

		// Add resize event listener to update swiper
		window.addEventListener("resize", () => {
			swiper.update();
		});
	});
})();
